export default __webpack_public_path__ + "static/media/seat.98ba4d88.svg";